import React from 'react';
import { MarketplaceTax } from '@spike/marketplace-model';
import TaxesSelector from 'components/UI/TaxesSelector/TaxesSelector';
import styles from './EvaluationTaxableService.module.scss';

interface EvaluationTaxableServiceProps {
    selectedTaxes: MarketplaceTax[];
    onUpdateTaxes: (taxes: MarketplaceTax[]) => void;
}

export const EvaluationTaxableService: React.FC<EvaluationTaxableServiceProps> = ({ selectedTaxes, onUpdateTaxes }) => {
    return (
        <div className={styles.section}>
            <TaxesSelector
                id="evaluation_taxable_service_selector"
                checked={selectedTaxes.length > 0}
                selectedTaxes={selectedTaxes}
                onChange={onUpdateTaxes}
                title="Taxable Service"
                subtitle="Choose the applicable tax for this service."
            />
        </div>
    );
};

export default EvaluationTaxableService;
